import { render, staticRenderFns } from "./ItemClassify.vue?vue&type=template&id=e04e19d4&scoped=true"
import script from "./ItemClassify.vue?vue&type=script&lang=js"
export * from "./ItemClassify.vue?vue&type=script&lang=js"
import style0 from "./ItemClassify.vue?vue&type=style&index=0&id=e04e19d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04e19d4",
  null
  
)

export default component.exports